import { TableCell, TableCellProps } from '@mui/material';
import { styled } from '@mui/styles';

export const PmiBodyTableCell = styled((props: TableCellProps) => <TableCell {...props} />)(() => ({
  padding: '8px 16px !important',
}));

export const PmiActionTableCell = styled((props: TableCellProps) => <TableCell {...props} />)(
  () => ({
    padding: '4px 12px !important',
  })
);
